import React, { useState, useCallback, useEffect } from 'react';
import { getList } from 'services/recruitment-apply.service';
import { defaultPaging, defaultParams, showToast } from 'utils/helpers';
import RecruitmentApplyTable from './components/main/RecruitmentApplyTable';
import RecruitmentApplyFilter from './components/main/RecruitmentApplyFilter';

const RecruitmentApplyPage = () => {
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState(defaultParams);
  const [dataList, setDataList] = useState(defaultPaging);

  const { items, itemsPerPage, page, totalItems, totalPages } = dataList;

  const loadData = useCallback(() => {
    setLoading(true);
    getList(params)
      .then(setDataList)
      .catch((err) => {
        showToast.error(err?.message ?? 'Có lỗi xảy ra');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [params]);
  useEffect(loadData, [loadData]);

  return (
    <React.Fragment>
      <div class='bw_main_wrapp'>
        <RecruitmentApplyFilter
          onChange={(e) => {
            setParams((prev) => {
              return {
                ...prev,
                ...e,
              };
            });
          }}
        />
        <RecruitmentApplyTable
          loading={loading}
          data={items}
          totalPages={totalPages}
          itemsPerPage={itemsPerPage}
          page={page}
          totalItems={totalItems}
          onChangePage={(page) => {
            setParams({
              ...params,
              page,
            });
          }}
          onRefresh={loadData}
        />
      </div>
    </React.Fragment>
  );
};

export default RecruitmentApplyPage;
